import { contentStyles } from "modules/storyblok/adapters/Content";
import type { RichtextAdapterProps } from "modules/storyblok/adapters/RichtextAdapter";

export const compensationFeeCardHeaderStyles: RichtextAdapterProps["customStyles"] = {
  ...contentStyles,
  heading: {
    ...contentStyles.heading,
    lineHeight: "short",
    marginTop: 0,
    marginBottom: 4,
    alignSelf: "self-start",
    textAlign: "left",
  },
};
